module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/manual-usage-167.vue");


//////////////////
// WEBPACK FOOTER
// ./en/install/manual-usage.md
// module id = 606
// module chunks = 425